import React, { useEffect, useRef } from "react";
import "./Hero.css";

const Hero = () => {
  const titleRef = useRef(null);
  const buttonRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const titleElement = titleRef.current;
    const buttonElement = buttonRef.current;
    const videoElement = videoRef.current;

    // Add animation classes
    if (titleElement) titleElement.classList.add("animate-title");
    if (buttonElement) buttonElement.classList.add("animate-button");

    // Ensure seamless video looping
    if (videoElement) {
      // Set video to preload for smoother playback
      videoElement.preload = "auto";
      
      // Function to handle seamless looping
      const handleTimeUpdate = () => {
        // If video is near the end (within 0.1 seconds), reset to beginning instantly
        if (videoElement.currentTime >= videoElement.duration - 0.1) {
          videoElement.currentTime = 0;
          // Ensure video keeps playing
          if (videoElement.paused) {
            videoElement.play().catch(err => console.log("Video playback error:", err));
          }
        }
      };

      // Add event listeners for seamless looping
      videoElement.addEventListener('timeupdate', handleTimeUpdate);
      
      // Handle any potential stalled or ended events
      const handleEnded = () => {
        videoElement.currentTime = 0;
        videoElement.play().catch(err => console.log("Video playback error:", err));
      };
      
      videoElement.addEventListener('ended', handleEnded);

      // Cleanup function
      return () => {
        if (titleElement) titleElement.classList.remove("animate-title");
        if (buttonElement) buttonElement.classList.remove("animate-button");
        videoElement.removeEventListener('timeupdate', handleTimeUpdate);
        videoElement.removeEventListener('ended', handleEnded);
      };
    }

    return () => {
      if (titleElement) titleElement.classList.remove("animate-title");
      if (buttonElement) buttonElement.classList.remove("animate-button");
    };
  }, []);

  return (
    <section className="hero" id="home" aria-label="Hero">
      {/* Background Video with Overlay */}
      <div className="hero__video-container">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="hero__video"
          aria-label="Background video"
        >
          <source src="./herooo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero__video-overlay" aria-hidden="true"></div>
      </div>

      {/* Content Container */}
      <div className="hero__content">
        <h1 className="hero__title" ref={titleRef}>
          Programs That Empower Families and Strengthen Communities
        </h1>

        <div className="hero__button-container">
          <a className="hero__button" href="/contact" ref={buttonRef}>
            Request an Appointment
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;